import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmenitiesComponent } from './amenities.component';
import { ImgHeaderModule } from '../../img-header/img-header.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ImgHeaderModule,
    SharedModule
  ],
  declarations: [
    AmenitiesComponent
  ]
})
export class AmenitiesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/amenities/amenities.module.ts